import { Routes, Route, Navigate } from "react-router-dom";

import MainDashboard from "./Main_Dashboard";
import MasterDesign from "./MasterDesign";
import JobCardCreation from "./JobCardCreation";
import PreCastingStages from "./Pre_Casting_Stages";
import PostCastingStages from "./Post_Casting_Stages";
import FinalQCPacking from "./FinalQC_Packing";
import WorkerPerformanceDashboard from "./WorkerPerformance";
import WorkerReport from "./WorkerReport";
import JobCardGantt from "./JobCardGantt";
import QCDashboard from "./QCDashboard";
import OrdersInbox from "./OrdersInbox";
import ProductionReworkQueue from "./ProductionReworkQueue";
import ModuleGoalsDashboard from "../Goals/ModuleGoalsDashboard";
import { BREAKPOINTS, PRODUCTION_THEME } from "./productionTheme";


function ProductionRouting({ onLogout }) {
  return (
    <div className="production-responsive-root">
      <style>{`
        :root {
          --production-brand: ${PRODUCTION_THEME.colors.brand};
          --production-brand-dark: ${PRODUCTION_THEME.colors.brandDark};
          --production-success: ${PRODUCTION_THEME.colors.success};
          --production-danger: ${PRODUCTION_THEME.colors.danger};
          --production-warning: ${PRODUCTION_THEME.colors.warning};
          --production-surface: ${PRODUCTION_THEME.colors.surface};
          --production-border: ${PRODUCTION_THEME.colors.border};
          --production-text: ${PRODUCTION_THEME.colors.textPrimary};
          --production-text-muted: ${PRODUCTION_THEME.colors.textMuted};
        }
        @media (max-width: ${BREAKPOINTS.mobile}) {
          .production-responsive-root .mobile-scroll-table { overflow-x: auto; }
          .production-responsive-root .mobile-modal { width: 100vw !important; height: 100vh !important; max-width: 100vw !important; border-radius: 0 !important; }
          .production-responsive-root .desktop-modal { width: 100%; max-width: 600px; }
          .production-responsive-root .kpi-grid-responsive { grid-template-columns: 1fr !important; }
        }
        @media (min-width: ${BREAKPOINTS.mobile}) and (max-width: ${BREAKPOINTS.desktop}) {
          .production-responsive-root .kpi-grid-responsive { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
        }
        @media (min-width: ${BREAKPOINTS.desktop}) {
          .production-responsive-root .kpi-grid-responsive { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; }
        }
      `}</style>
      <Routes>
      {/* 🔹 Redirect root */}
      <Route path="/" element={<Navigate to="/production" replace />} />

      {/* 🔹 Production Routes */}
      <Route path="/production" element={<MainDashboard onLogout={onLogout} />} />
      <Route path="/production/master-design" element={<MasterDesign />} />
      <Route path="/production/job-card" element={<JobCardCreation />} />
      <Route path="/production/pre-casting" element={<PreCastingStages />} />
      <Route path="/production/post-casting" element={<PostCastingStages />} />
      <Route path="/production/final-qc" element={<FinalQCPacking />} />
      <Route path="/production/qc-dashboard" element={<QCDashboard />} />
      <Route path="/production/rework-queue" element={<ProductionReworkQueue />} />
      <Route path="/production/worker-performance" element={<WorkerPerformanceDashboard />} />
      <Route path="/production/worker-report" element={<WorkerReport />} />
      <Route path="/production/gantt" element={<JobCardGantt />} />
      <Route path="/production/orders-inbox" element={<OrdersInbox />} />
      <Route path="/production/goals" element={<ModuleGoalsDashboard moduleName="PRODUCTION" backPath="/production" />} />
      {/* 🔹 Fallback (optional but recommended) */}
      <Route path="*" element={<Navigate to="/production" replace />} />
      </Routes>
    </div>
  );
}

export default ProductionRouting;
